export const enum ConfiguratorTabs {
  PRODUCT_EDITOR = 'product_editor',
  ROOM_PLANNER = 'room_planner',
  ROOM_DESIGNER = 'room_designer',
  SHOPPING_LIST = 'shopping_list'
}
